import { useMemo } from 'react'
import { format, addDays } from 'date-fns'
import { useRouter } from 'next/router'
import useBootstrapData from '@/hooks/useBootstrapData'
import { initialState } from '../SearchForm/utils'
import type { HOTEL_FORM_STATE_TYPE } from '../types'

// Hook to enable/handle Prepopulation, SEM, & initialization of form state
const useHotelFormInitialValues = () => {
  const { pathname, query } = useRouter()
  //   'ambig-hotel-city': ambigHotelCity, apart of query need to readd once implemented.
  const { SEMSearch, SEMSEARCH } = query
  const isHomepage = pathname === '/'

  const {
    isMobile,
    prePopData,
    signInStatus: { signedIn },
    webstats: { clientGUID: cguid }
  } = useBootstrapData()

  const {
    endLocation,
    startDate: prePopStartDate,
    roomCount
  } = prePopData?.hotels ?? {}

  const initialValues: HOTEL_FORM_STATE_TYPE = useMemo(() => {
    const isSemUSOutbound =
      !isHomepage &&
      !!endLocation?.countryCode &&
      endLocation?.countryCode !== 'US'

    return {
      ...initialState,
      ...(endLocation && { endLocation }),
      ...(!isSemUSOutbound && {
        startDate: prePopStartDate || format(new Date(), 'yyyyMMdd'),
        endDate: prePopStartDate || format(addDays(new Date(), 1), 'yyyyMMdd')
      }),
      ...(roomCount && {
        travelers: { ...initialState.travelers, rooms: roomCount }
      })
    }
  }, [endLocation, prePopStartDate, roomCount, isHomepage])

  return {
    initialValues,
    isMobile,
    signedIn,
    cguid,
    isHomepage,
    SEMSearch,
    SEMSEARCH
  }
}

export default useHotelFormInitialValues
